<template>
  <div class="col-sm-9 product-content">
    <div class="row">
      <!-- Items -->
      <router-link
        tag="div"
        v-for="(item, index) in items"
        :key="index"
        class="col-sm-3 mb-4 product-box"
        v-show="item.available"
        :to="`/service/${item.business_id}/${item.id}`"
      >
        <div class="product-box-num">
          <div class="product-box-img">
            <img :src="getImageUrl(item.img, 'service', 'service.jpg')" :alt="item.title" />
          </div>

          <!-- <div class="product-box-icon d-flex">
            <i class="icon-plus" @click.prevent="addToCard(item.id)"></i>
          </div> -->

          <div class="product-box-text d-flex">
            <!-- <i v-if="item.rate" class="icon-info"></i> -->
            <!-- <i v-else class="icon-heart"></i> -->
            <p v-text="item.title"></p>
          </div>

          <div class="product-box-price d-flex">
            <div class="discount d-flex" v-if="item.discount > 0">
              <span>{{ `${item.discount} %تخفیف` }}</span>
            </div>
            <div class="price d-flex">
              <span class="decoration" v-if="+item.price">{{
                `${item.price} تومان`
              }}</span>
              <span>{{ `${finalPrice(item.price, item.discount)} تومان` }}</span>
            </div>
          </div>
        </div>
      </router-link>
      <!-- Items -->
    </div>
  </div>
</template>

<script>
// import axios from "@/axios.js";
import { formErrors, url, getImageUrl } from "@/mixins.js";

export default {
  name: "Items",
  props: ["items"],
  mixins: [formErrors, url, getImageUrl],

  data() {
    return {
      proError: {
        login_err: "ابتدا وارد حساب کاربری خود شوید.",
      },
    };
  },

  created() {
    console.log("items:", this.items);
  },

  methods: {
    finalPrice(price, discount) {
      let disc = price * (discount / 100);
      disc = price - disc;

      return disc;
    },

    addToCard(pid) {
      if (!pid) return;
      this.$snotify.info("در دست توسعه");
    },
  },
};
</script>